import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

/**
 * Ícono de información con el detalle en tooltip. Reemplaza mensajes informativos en pantalla.
 * @param {Object} props
 * @param {Array<string>} props.lines Líneas de texto a mostrar.
 * @param {string} [props.color] Color del ícono (`primary`, `warning`, ...).
 * @param {string} [props.ariaLabel] Texto accesible del botón.
 * @returns {JSX.Element|null}
 */
const InfoTooltip = ({ lines = [], color = 'primary', ariaLabel = 'Información' }) => {
  const visibleLines = lines.filter(Boolean);
  if (!visibleLines.length) return null;

  return (
    <Tooltip
      arrow
      title={(
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
          {visibleLines.map((line) => (
            <Typography key={line} variant="caption" sx={{ lineHeight: 1.35 }}>
              {line}
            </Typography>
          ))}
        </Box>
      )}
    >
      <IconButton size="small" color={color} aria-label={ariaLabel}>
        <InfoOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
